module.exports = __webpack_public_path__ + "img/consolidado-praca-programa.b5cb72fe.png";